import ruleNames from '../../../constants/ruleNames';
import rulesShortDescription from './rulesShortDescription';

const ruleNameChoices = Object.values(ruleNames).map((ruleName) => ({
  id: ruleName,
  name: rulesShortDescription[ruleName],
}));

export default ruleNameChoices;
